import {nanoid} from "nanoid"

const meilensteinAmountLabelMap = {
    "1": "Meilenstein"
}

const milestoneExists = (milestoneList, milestoneId) => {
    return milestoneList.find((milestone) => milestone.id === milestoneId)
}

export const LebensmeilensteineAction = ({
    getDataFromPointer,
    updateData,
}) => {
    return {
        ADD_MILESTONE: () => {
            const localMilestoneData = getDataFromPointer("/appstate/localMilestone")
            const milestoneObjekt = getDataFromPointer("/appstate/selectedMilestone")
            const milestones = getDataFromPointer("/lebensmeilensteine/zonen")
            const newData = milestoneExists(milestones, localMilestoneData?.id) ? [...milestones.filter(el => el.id !== localMilestoneData.id), localMilestoneData ]: [...milestones, {...localMilestoneData, ...milestoneObjekt, position: {x: 0, y: -250}, id: nanoid()}]
            updateData({}, "/appstate/localMilestone")
            updateData(newData, "/lebensmeilensteine/zonen")
            updateData(`${newData.length} ${meilensteinAmountLabelMap[newData.length] ?? "Meilensteine"}`, "/appstate/milestoneCount")
            updateData(false, "/appstate/addMilestoneModalOpen")
        },
        OPEN_ADD_MILESTONE: (payload) => {
            const milestoneMitKategorie = {
                kategorie: payload.label
            }
            updateData(milestoneMitKategorie, "/appstate/localMilestone")
            updateData(payload, "/appstate/selectedMilestone")
            updateData(true, "/appstate/addMilestoneModalOpen")
        },
        CLOSE_ADD_MILESTONE: () => {
            updateData(false, "/appstate/addMilestoneModalOpen")
            updateData({}, "/appstate/localMilestone")
        },
        EDIT_MILESTONE: (payload) => {
            const milestones = getDataFromPointer("/lebensmeilensteine/zonen")
            const targetMilestone = milestones.find((milestone) => milestone.id === payload.id)
            updateData(targetMilestone, "/appstate/localMilestone")
            updateData(true, "/appstate/addMilestoneModalOpen")
        }
    }
}
